/* eslint-disable react/display-name */
import React from "react";

const HoverMenu = React.forwardRef(({ children, ...props }, ref) => (
  <div
    ref={ref}
    css={{
      padding: "0.5rem 0.5rem 0.5rem",
      position: "absolute",
      zIndex: 9000,
      top: "-10000px",
      left: "-10000px",
      marginTop: "-0.5rem",
      opacity: 0,
      backgroundColor: "#fff",
      borderRadius: "4px",
      transition: "opacity 0.25s",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    }}
    {...props}
  >
    {children}
  </div>
));

export default HoverMenu;
